import { EnvironmentProviders, Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { UsersEffects } from './+state/users.effects';
import { USERS_FEATURE_KEY, usersReducer } from './+state/users.reducer';
import { UsersStoreService } from './users-store.service';
import { UsersViewPermissionStoreService } from './users-view-permission-store.service';

/**
 * @used-by @scheduler-frontend/data-access-absence
 * @used-by @scheduler-frontend/data-access-approaches
 * @used-by @scheduler-frontend/data-access-assignment
 * @used-by @scheduler-frontend/data-access-awaiting-slots
 * @used-by @scheduler-frontend/data-access-business-entities
 * @used-by @scheduler-frontend/data-access-business-services
 * @used-by @scheduler-frontend/data-access-candidate-has-locations
 * @used-by @scheduler-frontend/data-access-candidates
 * @used-by @scheduler-frontend/data-access-candidates-by-slots
 * @used-by @scheduler-frontend/data-access-decline-reasons
 * @used-by @scheduler-frontend/data-access-location-schedules
 * @used-by @scheduler-frontend/data-access-locations
 * @used-by @scheduler-frontend/data-access-product-types
 * @used-by @scheduler-frontend/data-access-regions
 * @used-by @scheduler-frontend/data-access-roles
 * @used-by @scheduler-frontend/data-access-schedules
 * @used-by @scheduler-frontend/data-access-scheduling
 * @used-by @scheduler-frontend/data-access-search
 * @used-by @scheduler-frontend/data-access-search-location-statistics
 * @used-by @scheduler-frontend/data-access-slots
 * @used-by @scheduler-frontend/data-access-subjects
 * @used-by @scheduler-frontend/data-access-weekly-schedules
 */
export function provideUsersStore(): Provider | EnvironmentProviders[] {
  return [
    provideState({ name: USERS_FEATURE_KEY, reducer: usersReducer }),
    provideEffects(UsersEffects),
    UsersStoreService,
    UsersViewPermissionStoreService,
  ];
}
